var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryHosting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 14.9999C31.6667 21.4432 26.4433 26.6666 20 26.6666M31.6667 14.9999C31.6667 8.5566 26.4433 3.33325 20 3.33325M31.6667 14.9999H8.33333M20 26.6666C13.5567 26.6666 8.33333 21.4432 8.33333 14.9999M20 26.6666C22.9182 23.4718 24.5781 19.3259 24.6682 14.9999C24.5781 10.674 22.9182 6.528 20 3.33325M20 26.6666C17.0818 23.4718 15.425 19.3259 15.3349 14.9999C15.425 10.674 17.0818 6.528 20 3.33325M20 26.6666V29.9999M8.33333 14.9999C8.33333 8.5566 13.5567 3.33325 20 3.33325M23.3333 33.3333C23.3333 35.1742 21.8409 36.6666 20 36.6666C18.1591 36.6666 16.6667 35.1742 16.6667 33.3333M23.3333 33.3333C23.3333 31.4923 21.8409 29.9999 20 29.9999M23.3333 33.3333H35M16.6667 33.3333C16.6667 31.4923 18.1591 29.9999 20 29.9999M16.6667 33.3333H5",
    stroke: "#6374A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryHosting);
export default __webpack_public_path__ + "react/media/category-hosting.350e38ad990b3a958a3bc2b7014bf4cb.svg";
export { ForwardRef as ReactComponent };